var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"widget__header"},[_c('h3',{staticClass:"widget__heading"},[_vm._t("heading",function(){return [_vm._v(" "+_vm._s(_vm.heading)+" ")]})],2),(_vm.hint || _vm.$slots.hint)?_c('common-info-tip',[_vm._t("hint",function(){return [_vm._v(" "+_vm._s(_vm.hint)+" ")]})],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }